<template>
    <div class="table-container">
        <div class="table-header item-parent">
            <component
                class="item item-value"
                v-for="headerItem in headerItems"
                :item="headerItem"
                :is="headerItem.keyType"
                :key="headerItem.index"
                :class="headerItem.parentClass"
            />
        </div>
        <div
            class="table-body item-parent"
            v-for="(items,idx) in itemRows"
            :key="idx"
            :class="items.clickEvent !== undefined && clickedRow === items.clickEvent.key ? 'row_select' : ''"
            style="height: auto;"
            @click="items.clickEvent !== undefined && clickEvent($event, items.clickEvent.func, items.clickEvent.params, items.clickEvent.key)"
        >
            <component
                class="item item-value"
                v-for="(item,idxChild) in items"
                :is="item.keyType"
                :key="idxChild"
                :item="item"
                :class="item.class"
                style="word-break: break-word; line-height: 16px;"
            />
        </div>
    </div>
</template>
<script>
import Types from '@/components/Table/types'

export default {
  name: 'ListTable',
  components: {
    DefaultInput: Types.DefaultInput,
    RadioBox: Types.RadioBox,
    GenderRadioBox: Types.GenderRadioBox,
    EmailInput: Types.EmailInput,
    SingleDateInput: Types.SingleDateInput,
    DefaultInfoInput: Types.DefaultInfoInput,
    SelectBox: Types.SelectBox,
    ImageSelector: Types.ImageSelector,
    Default: Types.Default,
    HeaderDefault: Types.HeaderDefault,
    ImportantCheckBox: Types.ImportantCheckBox,
    DeleteBtn: Types.DeleteBtn
  },
  props: [
    'headerItems',
    'itemRows',
    'selectedRowIndex',
  ],
  data() {
    return {
      clickedRow: ''
    }
  },
  methods: {
    clickEvent($event, func, params = {}, key = 'none') {
      if (key !== 'none') {
        this.clickedRow = key;
      }
      if (func) {
        func($event, ...params);
      }
    }
  },
  watch: {
    selectedRowIndex: {
      deep: true,
      handler(newValue) {
        if (newValue === '')
          this.clickedRow = '';
      }
    },
  }
}
</script>
<style lang="scss" scoped>
    .table-container {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 50px;
      width: 100%;

      .table-header {
        font-weight: bold;
        overflow: hidden;
      }

      .item-parent {
        display: flex;
        flex-direction: row;
        align-items: center;
        text-align: center;

        &.row_select {
          background: var(--blue10);
          border: 1px solid var(--blue70);
          border-radius: 10px;
        }

        &.columns_2 {
          grid-column: 1/3;
        }

        &.row_2 {
          grid-row: 1/3;
        }

        .item {
          //border-right: 1px solid var(--grey20);
          padding: 15px 0;
          overflow: hidden;

          &.item-title {
            flex: 1 1 1rem;
          }

          &.item-value {
            flex: 3 3 1rem;
          }

          &:nth-last-child(1) {
            border-right: none;
          }
        }
      }

      .table-body {
        border-bottom: 1px solid var(--grey20);

        &:hover {
          transition: background-color 0.5s;
          background-color: #f7fbff;
        }
      }
    }
</style>